import TrailResults from './TrailResults';

export default TrailResults;
